export const API_BASE =
    process.env.NODE_ENV === "production"
        ? process.env.REACT_APP_API
        : "http://localhost:4000";


export const EMP_PROFILE_FILE_BASE =
    process.env.NODE_ENV === "production"
        ? process.env.REACT_APP_EMP_PROFILE_FILE
        : "http://localhost:4002";

// dAdmin owns the global sign-in config (banners, figures, two-step). Read-only,
// unauthenticated, read cross-origin from every dApp's sign-in screen.
export const DADMIN_API_BASE =
    process.env.NODE_ENV === "production"
        ? process.env.REACT_APP_DADMIN_API
        : "http://localhost:4002";

// An admin revoking someone in dAdmin now ends their session. The server
// answers 401 SESSION_REVOKED on the next request; without this the page would
// render broken data and leave the person apparently signed in.
//
// Handled here rather than per page so it cannot be forgotten by one caller.
// Guarded so a burst of parallel requests cannot cause a redirect loop, and
// skipped on the sign-in routes, where a 401 is an ordinary answer.
let sessionEnded = false;

// Where to go after signing in: a page of this app ("/forms/..."), never
// another site ("//x", "https://...") and never the sign-in page itself.
export const safeReturnPath = (path) =>
    typeof path === "string" && /^\/(?![/\\])/.test(path) && !/^\/login\b/i.test(path) ? path : null;

export function rememberPageForLogin() {
    try {
        const path = safeReturnPath(window.location.pathname + window.location.search);
        if (path) sessionStorage.setItem("redirectAfterLogin", path);
    } catch { /* storage unavailable */ }
}

// Read once after signing in: the saved page, or /home.
export function pageAfterLogin() {
    try {
        const path = safeReturnPath(sessionStorage.getItem("redirectAfterLogin"));
        sessionStorage.removeItem("redirectAfterLogin");
        return path || "/home";
    } catch {
        return "/home";
    }
}

export async function apiFetch(endpoint, options = {}) {
    const res = await fetch(`${API_BASE}${endpoint}`, {
        credentials: "include",
        ...options,
    });

    if (res.status === 401 && !sessionEnded && !endpoint.startsWith("/api/login/")) {
        let message = "";
        // Read from a clone so the caller still gets an unconsumed body.
        try { message = (await res.clone().json())?.message || ""; } catch { /* not JSON */ }
        if (message === "SESSION_REVOKED") {
            sessionEnded = true;
            window.location.replace("/login?revoked=1");
        }
        // The session timed out (12 hours idle or 7 days after signing in).
        // Sign in again, then come back to this page; a half-filled form's
        // answers are kept in this browser.
        if (message === "SESSION_EXPIRED") {
            sessionEnded = true;
            rememberPageForLogin();
            window.location.replace("/login?expired=1");
        }
    }

    return res;
}
